import {
  AVAILABLE_CHIP_TAGS,
  CUSTOM_TAG,
  CUSTOM_TAG_NAME,
  CUSTOM_TAG_VALUE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_IAB,
  SYSTEM_TAG_KEYWORDS,
  SYSTEM_TAG_PEOPLE,
} from '../constants/label';

import { WatchType } from '@/modules/common/types';
import { TMVideoType, VideoType } from '@/modules/common/types/video';

import { createFlatTreeMap } from '@/mui/helpers/treeView';

import { getIntersection } from './array';

let allowedChipTagTypes = [...AVAILABLE_CHIP_TAGS];

export const setAllowedChipTagTypes = (tagTypes: WatchType['tagTypes']) => {
  allowedChipTagTypes = tagTypes;
};

export const collectVideoEntities = (video: TMVideoType) => {
  const entities: { id?: string; type: (typeof AVAILABLE_CHIP_TAGS)[number]; value: string }[] = [];

  if (allowedChipTagTypes.includes(SYSTEM_TAG_IAB) && video?.iab?.categories) {
    createFlatTreeMap(video.iab.categories, {
      label: 'name',
      children: 'categories',
    }).forEach((iab$) => {
      entities.push({
        id: iab$.id,
        type: SYSTEM_TAG_IAB,
        value: iab$.label,
      });
    });
  }

  if (getIntersection(allowedChipTagTypes, [SYSTEM_TAG_PEOPLE, SYSTEM_TAG_BRANDS, SYSTEM_TAG_KEYWORDS]).length) {
    (video.keywords || []).forEach((keyword) => {
      if (allowedChipTagTypes.includes(keyword.category)) {
        entities.push({
          type: keyword.category,
          value: keyword.value,
        });
      }
    });
  }

  const allowedName = allowedChipTagTypes.includes(CUSTOM_TAG_NAME);
  const allowedValue = allowedChipTagTypes.includes(CUSTOM_TAG_VALUE);
  if (allowedName || allowedValue) {
    (video.label || []).forEach((label$) => {
      if (allowedName) {
        entities.push({
          type: CUSTOM_TAG_NAME,
          value: label$.name,
        });
      }

      if (allowedValue) {
        entities.push({
          type: CUSTOM_TAG_VALUE,
          value: label$.value,
        });
      }
    });
  }

  return entities;
};

type NormalizedTagType =
  | Exclude<WatchType['tagTypes'][number], typeof CUSTOM_TAG_NAME | typeof CUSTOM_TAG_VALUE>
  | typeof CUSTOM_TAG;

export const getVideoEntityTypes = (tagTypes?: WatchType['tagTypes']) => {
  const input = tagTypes ?? [];

  const backTabsResult: NormalizedTagType[] = [];

  input.forEach((tag) => {
    if (tag === CUSTOM_TAG_NAME || tag === CUSTOM_TAG_VALUE) {
      if (!backTabsResult.includes(CUSTOM_TAG)) {
        backTabsResult.push(CUSTOM_TAG);
      }
    } else {
      backTabsResult.push(tag);
    }
  });

  return backTabsResult;
};

export const filterVideosByChip = (
  videos: VideoType[],
  allowedChipTypes: WatchType['tagTypes'],
  selectedChip: string,
) => {
  if (!selectedChip) {
    return videos;
  }

  const selectedChipLowerCase = selectedChip.toLowerCase();

  return videos.filter((video) =>
    video.videoEntities.some(
      (videoEntity) =>
        allowedChipTypes.includes(videoEntity.type) && videoEntity.value.toLowerCase() === selectedChipLowerCase,
    ),
  );
};
